module.exports = __webpack_public_path__ + "img/record.c23e729c.png";